import { Menu, Transition } from "@headlessui/react";
import {
  FolderIcon,
  HomeIcon,
  LogoutIcon,
  ShoppingBagIcon,
  UserIcon,
} from "@heroicons/react/outline";
import { Fragment } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { useCart } from "react-use-cart";
import useAuth from "../hooks/useAuth";
import useLogout from "../hooks/useLogout";
import MiniCart from "./MiniCart";
import { MotorsIcon, PartsIcon } from "../assets/icons/CategoryIcons";

const NavBar = () => {
  const { auth } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { emptyCart } = useCart();

  return (
    <div className="items-center hidden space-x-10 lg:flex">
      <Menu as="div" className="relative flex">
        <Menu.Button className="inline-flex items-center">
          <div>
            <span className="font-medium">{auth.customer.firstName}</span>{" "}
            <span className="inline-flex text-xs">
              (
              <span className="max-w-[100px] truncate ...">
                {auth.customer.companyName}
              </span>
              )
            </span>
          </div>
          <UserIcon className="w-5 h-5 ml-2" />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <Menu.Items className="absolute z-10 px-6 py-8 mt-2 -translate-x-1/2 bg-white shadow-xl left-1/2 min-w-max top-full w-60">
            <div className="pb-2 mb-6 text-lg font-bold uppercase border-b-2 border-yellow">
              {t("Hello")} {auth.customer.firstName}
            </div>

            <div className="space-y-2 font-medium">
              <div className="block">
                <Menu.Item>
                  <NavLink
                    to="/dashboard"
                    className="inline-flex items-center transition hover:text-yellow"
                  >
                    <HomeIcon
                      className="w-5 h-5 mr-2 duration-150"
                      aria-hidden="true"
                    />
                    <span>{t("Dashboard")}</span>
                  </NavLink>
                </Menu.Item>
              </div>

              <div className="block">
                <Menu.Item>
                  <NavLink
                    to="/dashboard/orders"
                    className="inline-flex items-center transition hover:text-yellow"
                  >
                    <ShoppingBagIcon
                      className="w-5 h-5 mr-2 duration-150"
                      aria-hidden="true"
                    />
                    <span>{t("Orders")}</span>
                  </NavLink>
                </Menu.Item>
              </div>

              <div className="block">
                <Menu.Item>
                  <NavLink
                    to="/dashboard/quotations"
                    className="inline-flex items-center transition hover:text-yellow"
                  >
                    <FolderIcon
                      className="w-5 h-5 mr-2 duration-150"
                      aria-hidden="true"
                    />
                    <span>{t("Quotations")}</span>
                  </NavLink>
                </Menu.Item>
              </div>

              <div className="block">
                <Menu.Item>
                  <NavLink
                    to="/dashboard/MyMachines"
                    className="inline-flex items-center transition hover:text-yellow"
                  >
                    <PartsIcon
                      className="w-5 h-5 mr-2 duration-150"
                      aria-hidden="true"
                    />
                    <span>{t("My Machines")}</span>
                  </NavLink>
                </Menu.Item>
              </div>

              <div className="block">
                <Menu.Item>
                  <NavLink
                    to="/dashboard/MyEngines"
                    className="inline-flex items-center transition hover:text-yellow"
                  >
                    <MotorsIcon
                      className="w-5 h-5 mr-2 duration-150"
                      aria-hidden="true"
                    />
                    <span>{t("My Engines")}</span>
                  </NavLink>
                </Menu.Item>
              </div>

              <button
                onClick={() => {
                  emptyCart();

                  logout();

                  navigate("/login", { replace: true });

                  toast.success(t("Successfully logged out"));
                }}
                className="inline-flex items-center transition hover:text-yellow"
              >
                <LogoutIcon
                  className="w-5 h-5 mr-2 duration-150"
                  aria-hidden="true"
                />
                <span>{t("Logout")}</span>
              </button>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>

      <MiniCart />
    </div>
  );
};

export default NavBar;
